/** ******* 使用方法 *********
 *
 * 1. 在index.html中引入OSS  <script src="http://gosspublic.alicdn.com/aliyun-oss-sdk-4.4.4.min.js"></script>
 *
 * 2. 配置参数说明
*      1） AWconfig为阿里云图片地址配置，基本结构如下，注意至少要包含一个键名为'aliyunConfig'的对象：
{
"aliyunConfig":{
"endpoint": "https://example1.aliyuncs.com/",
"bucket": "example2-image",
"url":"https://example3.oss-cn-shenzhen.aliyuncs.com"
}
}
*      2） token为请求阿里云服务的唯一token，由后端接口返回，有效期为60分钟，注意此参数必须为一个包含三个指定键名的对象，如下：
{
accessKeyId: 'accessKeyIdFromAPI';
accessKeySecret: 'accessKeySecretFromAPI';
securityToken: 'securityTokenFromAPI';
}
 *
 * 3. 在要使用阿里云上传服务的页面中加载时即进行配置，将上述参数传给config方法，此方法返回闭包函数，因此需要一个变量接收
*      let someFn = new Aliyun().config({
*      AWconfig: AWconfig,
*      token: token,
*      })
 *    在上传图片的组件中调用someFn方法，如下：
 *      someFn(callback, file) {
 *          callback为此方法执行后的回调函数，此函数接收两个参数如下：
 *          callback(url, aliyunResult) {
 *              url为上传后的已保存在阿里云服务器的图片地址
 *              aliyunResult为阿里云服务器返回的response数据，可进行其他操作
 *          }
 *
 *          file为上传的事件的file，即event.file
 *      }
 *
 * 4. 异常说明
 *      1） token过期，执行someFn(callback, file)时会返回errorCode == 'aliyun-000'，捕捉此异常后需要重新向后端请求获取token
 *      2） 参数异常，config()方法中会先执行校验参数，如果参数不符合规定，将会throw new Error()，可在程序中捕捉此异常
 *
 *
 */
import md5 from 'md5'
import Cookie from 'js-cookie'
import store from '../../store'
export default class Aliyun {
  constructor () {
    if (!window.OSS) {
      throw new Error('需要引入OSS')
    }
    // 绑定this指向为本class内方法，否则会指向实例而报错
    this.config = this.config.bind(this)
  }
  // 错误信息
  errorMsgs () {
    return {
      expire: {
        errorCode: 'aliyun-000',
        errorMsg: 'token已过期，请重新获取',
      },

    }
  }

  // 检验参数
  validate (obj) {
    if (!(obj instanceof Object)) {
      throw new Error('config需传入对象作为参数')
    }
    if (!(obj.AWconfig instanceof Object)) {
      throw new Error('需要AWconfig对象')
    }
    if (!(obj.AWconfig.aliyunConfig instanceof Object)) {
      throw new Error('需要AWconfig.aliyunConfig对象')
    }
    if (!(obj.token instanceof Object)) {
      throw new Error('需要token对象')
    }
    if (!this.judgeParam(obj.AWconfig.aliyunConfig, ['endpoint', 'bucket', 'url'])) {
      throw new Error('AWconfig对象键错误')
    }
    if (!this.judgeParam(obj.token, ['accessKeyId', 'accessKeySecret', 'securityToken'])) {
      throw new Error('token对象键错误')
    }
  }
  // 执行配置
  config (obj) {
    this.validate(obj)

    let accessKeyId = ''
    let accessKeySecret = ''
    let securityToken = ''
    let url = ''

    // 执行配置
    let cookieString = document.cookie
    let arr = cookieString.split(';')

    if (cookieString.indexOf('accessKeyId') > -1) {
      for (let key in arr) {
        if (arr[key].indexOf('accessKeyId') > -1) {
          accessKeyId = arr[key].split('=')[1]
        }
        if (arr[key].indexOf('accessKeySecret') > -1) {
          accessKeySecret = arr[key].split('=')[1]
        }
        if (arr[key].indexOf('securityToken') > -1) {
          securityToken = arr[key].split('securityToken=')[1]
        }
      }
    } else if (obj.token) {
      accessKeyId = obj.token.accessKeyId
      accessKeySecret = obj.token.accessKeySecret
      securityToken = obj.token.securityToken
      // 阿里云token缓存有效期为60分钟，因此这里设置小于60分钟 js-cookie过期时间单位是天
      let expiresTime = { expires: new Date(new Date().getTime() + 50 * 60 * 1000) }
      Cookie.set('accessKeyId', accessKeyId, expiresTime)
      Cookie.set('accessKeySecret', accessKeySecret, expiresTime)
      Cookie.set('securityToken', securityToken, expiresTime)
    } else {
      throw this.errorMsgs.expire
    }
    return function getAliyunFile (fn, file) { // OSS Function
      let cookieString = document.cookie
      if (cookieString.indexOf('accessKeyId') < 0) {
        throw this.errorMsgs.expire
      }
      // 文件后缀
      let suffix = '.' + file.name.split('.').reverse()[0]
      var strFormat = String(new Date().getTime() + file.name)
      var storeAs = md5(strFormat) + suffix
      var aliyunConfig = obj.AWconfig.aliyunConfig
      /* eslint-disable */
      var client = new OSS.Wrapper({
        accessKeyId: accessKeyId,
        accessKeySecret: accessKeySecret,
        stsToken: securityToken,
        endpoint: aliyunConfig.endpoint,
        bucket: aliyunConfig.bucket
      })
      /* eslint-disable */

      client.multipartUpload(storeAs, file).then(function (result) {
        // let jsonstr = JSON.stringify(result);
        url = aliyunConfig.url + '/' + result.name
        fn(url, result)
      }).catch(function (err) {
        console.log('错误：' + err)
        Cookie.remove('accessKeyId')
        Cookie.remove('accessKeySecret')
        Cookie.remove('securityToken')
        store.commit('setAliyunFileToken', null)
        store.state.file.aliyunFileToken = null // 用于报错时取消正在上传状态

      })
    }
  }
  // 校验参数对象是否包含指定键
  judgeParam (obj, keyList) {
    let pass = true
    // obj转为Map对象
    let objMap = new Map()
    for (let k of Object.keys(obj)) {
      objMap.set(k, obj[k])
    }
    // Map.has方法可判断是否包含指定键
    for (let k of keyList) {
      if (!objMap.has(k)) {
        pass = false
        // console.log(`%c所需要的键${k}不存在`, 'color:red')
        break
      }
    }
    return pass
  }
}
